import React from 'react';
import OptimizedImage from '../../OptimizedImage';

const HowWeDoAbout = () => {
  return (
    <div className="container container-full">
      <div className="info-image">
        <div className="body">
          <div className="subtitle bigger">
            <div className="extra">
              Your IT project requires an idea and a solid business
              justification. We will help you with the rest.
            </div>
          </div>
          <div className="content">
            <p>
              Our cooperation with customers is planned according to a
              structured process so you know what happens, when it happens and
              how it happens.
            </p>
            <p>Let’s take a look.</p>
          </div>
        </div>
        <OptimizedImage
          src="how-we-do/howwedo_photo.png"
          background
          className="image"
        >
          <div className="image" />
        </OptimizedImage>
      </div>
    </div>
  );
};

export default HowWeDoAbout;
